import { Component, Input } from '@angular/core';
import { FormGroup, AbstractControl, FormArray } from '@angular/forms';

import { IItemAnswerCode } from '../../types';

@Component({
  selector: '[appCriterion]',
  styleUrls: ['./criterion.component.scss'],
  templateUrl: './criterion.component.html'
})
export class CriterionComponent {

  @Input()
  set parentControl(control: AbstractControl) {
    this._parentForm = control as FormGroup;
  }

  @Input()
  inclusion: boolean;

  @Input()
  index: number;

  @Input()
  label: string;

  get ineligible(): boolean {
    const value = (this.parentForm.get('answer') as FormArray).controls[0].get('valueCoding.code').value as IItemAnswerCode;

    return (this.inclusion && value === 'not-met') || (!this.inclusion && value === 'met');
  }

  get parentForm(): FormGroup {
    return this._parentForm;
  }

  _parentForm: FormGroup;

}
